import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AllCampaignsLoadAction } from '../../domains/allCampaigns/actions.types';
import { CampaignsListLoadMoreFulfilledAction } from '../../domains/allCampaigns/loadMoreAllCampaignsActions.types';
import { getAllCampaignsKey } from '../../domains/allCampaigns/selectors';

import { AllCampaigns } from './types';

const initialState: AllCampaigns = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

type AllCampaignsActions = AllCampaignsLoadAction | CampaignsListLoadMoreFulfilledAction;

const reducer: Reducer<AllCampaigns, AllCampaignsActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_CAMPAIGNS.LOAD_PENDING':
      return moveToPending(state, [getAllCampaignsKey(action.payload.options)]);
    case 'ALL_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, {
        [getAllCampaignsKey(action.payload.options)]: {
          id: getAllCampaignsKey(action.payload.options),
          campaignIds: action.payload.entities.sortedCampaigns?.campaignIds || [],
          ...action.payload.entities.sortedCampaigns,
        },
      });
    case 'ALL_CAMPAIGNS.LOAD_MORE_FULFILLED':
      return update(state, getAllCampaignsKey(action.payload.options), {
        ...action.payload.entities.sortedCampaigns,
        campaignIds: [
          ...(state.fulfilled.byId[getAllCampaignsKey(action.payload.options)]?.campaignIds || []),
          ...(action.payload.entities.sortedCampaigns?.campaignIds || []),
        ],
      });
    case 'ALL_CAMPAIGNS.LOAD_REJECTED':
      return moveToRejected(state, [getAllCampaignsKey(action.payload.options)], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
